<div class="top-bar d-flex flex-wrap justify-content-between align-items-center mb-4">
    <app-back-navigation [backTitle]="'buttons.back'" (onClickBack)="onGoBack()" [action]="!isCreatingNew ? 'buttons.delete' : ''" [actionIconClass]="'bi bi-trash-fill'" (onClickAction)="onDeleteProfile()"></app-back-navigation>
  
    <div class="button-group d-flex flex-wrap gap-2 justify-content-end justify-content-sm-between">
      <button class="btn btn-secondary btn-preview"
              [disabled]="isPreviewDisabled" 
              (click)="onPreviewProfile()"
              >{{ previewButtonLabel | translate }}</button>
      <button class="btn btn-primary btn-publish"
              [disabled]="isPublishDisabled" 
              (click)="onPublishProfile()">{{ publishButtonLabel | translate }}</button>
    </div>
</div>
